"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var js_base64_1 = require("js-base64");
var template_1 = require("./template");
var SEND_SEPARATOR = '::';
var RECEIVE_SEPARATOR = ':::';
function buildMessage(params) {
    return params.join(SEND_SEPARATOR);
}
exports.buildMessage = buildMessage;
function normalize(data) {
    if (!data.type) {
        throw new Error('message data structure is not correct');
    }
    var result = '';
    switch (data.type) {
        case template_1.MessageType.RPC: {
            var type = data.type, requestId = data.requestId, service = data.service, method = data.method, body = data.body;
            result = buildMessage([
                type,
                requestId,
                service,
                method,
                js_base64_1.Base64.encode(JSON.stringify(body))
            ]);
            break;
        }
        case template_1.MessageType.HEART: {
            var type = data.type, requestId = data.requestId;
            result = buildMessage([type, requestId]);
            break;
        }
        case template_1.MessageType.MESSAGE_ACK: {
            var type = data.type, requestId = data.requestId;
            result = buildMessage([type, requestId]);
            break;
        }
    }
    // console.log('send', result);
    return result;
}
exports.normalize = normalize;
function parse(input) {
    var result = '';
    try {
        var _a = input.split(RECEIVE_SEPARATOR), type = _a[0], requestId = _a[1], rest = _a.slice(2);
        switch (type) {
            case template_1.MessageType.ERROR:
                break;
            case template_1.MessageType.HEART:
                result = {
                    type: type,
                    requestId: requestId
                };
                break;
            case template_1.MessageType.RPC: {
                var service = rest[0], method = rest[1], rpcData = rest[2];
                var parsedRpcData = JSON.parse(js_base64_1.Base64.decode(rpcData));
                result = {
                    type: type,
                    requestId: requestId,
                    service: service,
                    method: method,
                    body: parsedRpcData
                };
                break;
            }
            case template_1.MessageType.MESSAGE: {
                var messageData = rest[0];
                var parsedMessageData = JSON.parse(js_base64_1.Base64.decode(messageData));
                result = {
                    type: type,
                    requestId: requestId,
                    body: parsedMessageData
                };
                break;
            }
        }
    }
    catch (e) {
        console.log(e);
    }
    return result;
}
exports.parse = parse;
function isString(value) {
    var type = typeof value;
    return (type == 'string' ||
        (type == 'object' &&
            value != null &&
            !Array.isArray(value) &&
            Object.prototype.toString.call(value) == '[object String]'));
}
exports.isString = isString;
var idCounter = {};
function uniqueId(prefix) {
    if (prefix === void 0) { prefix = '$uniqueId$'; }
    if (!idCounter[prefix]) {
        idCounter[prefix] = 0;
    }
    var id = ++idCounter[prefix];
    if (prefix === '$lodash$') {
        return "" + id;
    }
    return "" + (prefix + id);
}
exports.uniqueId = uniqueId;
function parseClientMsg(msg) {
    var result = '';
    try {
        var _a = msg.split(SEND_SEPARATOR), type = _a[0], requestId = _a[1], rest = _a.slice(2);
        // console.log(type, requestId, rest);
        switch (type) {
            case template_1.MessageType.HEART:
                result = {
                    type: type,
                    requestId: requestId
                };
                break;
            case template_1.MessageType.RPC: {
                var service = rest[0], method = rest[1], rpcData = rest[2];
                var parsedRpcData = JSON.parse(js_base64_1.Base64.decode(rpcData));
                result = {
                    type: type,
                    requestId: requestId,
                    service: service,
                    method: method,
                    body: parsedRpcData
                };
                break;
            }
            case template_1.MessageType.MESSAGE_ACK: {
                result = {
                    type: type,
                    requestId: requestId
                };
                break;
            }
        }
    }
    catch (e) {
        console.log(e);
    }
    return result;
}
exports.parseClientMsg = parseClientMsg;
//# sourceMappingURL=utils.js.map